import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, ComposedChart } from 'recharts';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

interface DynamicData {
  year: number;
  countArrived: number;
  countDeparted: number;
}

interface DinamicTableProps {
  data?: DynamicData[];
}

export const DinamicTable: React.FC<DinamicTableProps> = ({ data = [] }) => {
  const { t } = useTranslation(); 
  const currentYear = new Date().getFullYear();
  const lastThreeYears = [currentYear - 2, currentYear - 1, currentYear];
  
  const chartData = lastThreeYears.map(year => {
    const yearData = data.find(item => item.year === year);
    return {
      месяц: year.toString(),
      [t('arrived')]: yearData?.countArrived || 0,
      [t('departed')]: yearData?.countDeparted || 0
    };
  });


  const maxValue = Math.max(
    ...chartData.map(item => Math.max(Number(item[t('arrived')]), Number(item[t('departed')])))
  );


  const step = Math.ceil(maxValue / 4);
  const roundedMax = (Math.ceil(maxValue / step) + 1) * step;

  const yAxisTicks = [];
  for (let i = 0; i <= roundedMax; i += step) {
    yAxisTicks.push(i);
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('Dynamics of employee arrivals and departures')}</h2>
      <div className={styles.chartContainer}>
        <ResponsiveContainer>
          <ComposedChart data={chartData}>
            <defs>
              <linearGradient id="colorПрибыло" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="colorУбыло" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#ffa500" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#ffa500" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#f5f5f5" />
            <XAxis 
              dataKey="месяц" 
              axisLine={false}
              tickLine={false}
            />
            <YAxis 
              axisLine={false}
              tickLine={false}
              domain={[0, roundedMax]}
              ticks={yAxisTicks}
              allowDecimals={false}
            />
            <Tooltip 
              contentStyle={{
                background: '#fff',
                border: 'none',
                borderRadius: '8px',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                padding: '10px'
              }}
            />
            <Legend />
            <Area
              type="monotone"
              dataKey={t('arrived')}
              stroke="#82ca9d"
              strokeWidth={2}
              fill="url(#colorПрибыло)"
              fillOpacity={1}
            />
            <Area
              type="monotone"
              dataKey={t('departed')}
              stroke="#ffa500"
              strokeWidth={2}
              fill="url(#colorУбыло)"
              fillOpacity={1}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};